// Function to write order details to localStorage
export function writeOrderDetailsInLocalStorage(order) {
    if (!order || typeof order !== 'object') {
        alert('Ugyldige ordredetaljer angivet. Kontakt os for assistance.');
        throw new Error('bad order inptu');
    }
    try {
        const orderDetails = JSON.stringify(order);
        localStorage.setItem('penlyOrderDetails', orderDetails);
    } catch (error) {
        alert('Fejl ved gemning af ordredetaljer. Kontakt os for assistance.');
        throw error;
    }
}

// Function to get order details from localStorage
export function getOrderDetailsFromLocalStorage() {
    try {
        const orderDetails = localStorage.getItem('penlyOrderDetails');

        if (orderDetails) {
            const parsedOrder = JSON.parse(orderDetails);
            return parsedOrder;
        }
        return null;
    } catch (error) {
        alert(`Fejl ved hentning af ordredetaljer: ${  error  }. Kontakt os for assistance.`);
        throw error;
    }
}
